import CarouselDisplayTrigger from '../enums/CarouselDisplayTrigger';
import PaymentMethod from '../enums/PaymentMethod';
import ProductType from '../enums/ProductType';
import PurchaseScreenType from '../enums/PurchaseScreenType';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';
import WebProPurchaseLocation from '../enums/WebProPurchaseLocation';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logPurchaseButtonTappedParams = {
  action_type?: string;
  campaign_id?: string;
  carousel_item?: string;
  carousel_type?: string;
  initial_carousel_item?: string;
  payment_method?: PaymentMethod;
  product?: string;
  product_type?: ProductType;
  purchase_screen_type?: PurchaseScreenType;
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  trigger?: CarouselDisplayTrigger;
  upsell_trigger?: UpsellTrigger;
  web_purchase_location?: WebProPurchaseLocation;
};

/**
 * The user tapped on the purchase button.
 * @param params - Attributes to log with the amplitude event
 * @param params.action_type - Imported from a Firebase call
 * @param params.campaign_id - Imported from a Firebase call
 * @param params.carousel_item - Imported from a Firebase call
 * @param params.carousel_type - Imported from a Firebase call
 * @param params.initial_carousel_item - Imported from a Firebase call
 * @param params.payment_method - The method of payment used for the purchase.
 * @param params.product - Imported from a Firebase call
 * @param params.product_type - The subscription type selected from the upsell menu (e.g. free, plus, peak)
 * @param params.purchase_screen_type - The type of screen the pro purchasing event occurs on (e.g. pro carousel, upsell drawer, etc.)
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.trigger - Action that triggered the carousel display
 * @param params.upsell_trigger - Action that triggered the upsell to display
 * @param params.web_purchase_location - The location where the purchase was performed
 */
const logPurchaseButtonTapped = (
  {
    action_type,
    campaign_id,
    carousel_item,
    carousel_type,
    initial_carousel_item,
    payment_method,
    product,
    product_type,
    purchase_screen_type,
    purchase_screen_type_plan,
    trigger,
    upsell_trigger,
    web_purchase_location
  }: logPurchaseButtonTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'purchase button tapped',
    {
      'action type': action_type,
      'campaign id': campaign_id,
      'carousel item': carousel_item,
      'carousel type': carousel_type,
      'initial carousel item': initial_carousel_item,
      'payment method': payment_method,
      product,
      'product type': product_type,
      'purchase screen type': purchase_screen_type,
      'purchase screen type plan': purchase_screen_type_plan,
      trigger,
      'upsell trigger': upsell_trigger,
      'web purchase location': web_purchase_location
    },
    callback
  );
};

export default logPurchaseButtonTapped;
